import React, { useMemo } from "react";
import PageTitle from "../../../components/Common/PageTitle/index";
import { CustomBtn } from "../../../components/Common/CustomBtn";
import {
  PAGE_TITLE,
  PAGE_TEXT,
  PARAGRAPH_1,
  PARAGRAPH_2,
  SCHEDULE_CONFIG,
  SCHEDULE_PAGE_URL,
  IMAGE,
  NEXT_MEETING_LABEL,
  BUTTON_JOIN_MEETING,
  BUTTON_VIEW_SCHEDULE,
} from "./CommunitySupportGroups.constants";
import {
  getNextWednesday,
  getWeekOfMonth,
  isExceptionDate,
} from "./CommunitySupportGroups.utils";
import {
  RootBox,
  ContentWrapper,
  Image as StyledImage,
  BodyTypography,
  CardBox,
  CardTitleTypography,
  CardDateTimeTypography,
  JoinButtonWrapper,
} from "./CommunitySupportGroups.styles";

const useNextMeeting = (config) =>
  useMemo(() => {
    let nextWed = getNextWednesday(new Date());

    while (isExceptionDate(nextWed, config.exceptionDates)) {
      nextWed.setDate(nextWed.getDate() + 7);
    }

    const weekOfMonth = getWeekOfMonth(nextWed);
    const bucket =
      weekOfMonth === 1 || weekOfMonth === 3
        ? config.firstThird
        : config.secondFourth;

    const formattedDate = nextWed.toLocaleDateString(undefined, {
      weekday: "long",
      month: "long",
      day: "numeric",
    });

    return {
      date: formattedDate,
      time: bucket.timeLabel,
      url: bucket.url,
    };
  }, [config]);

const CommunitySupportGroups = () => {
  const nextMeeting = useNextMeeting(SCHEDULE_CONFIG);

  const handleJoinMeeting = () => window.open(nextMeeting.url, "_blank");
  const handleViewSchedule = () => window.open(SCHEDULE_PAGE_URL, "_blank");

  return (
    <RootBox>
      <PageTitle noIcon title={PAGE_TITLE} text={PAGE_TEXT} />

      <ContentWrapper>
        <StyledImage src={IMAGE.src} alt={IMAGE.alt} />

        <BodyTypography>{PARAGRAPH_1}</BodyTypography>
        <BodyTypography>{PARAGRAPH_2}</BodyTypography>

        <CardBox>
          <CardTitleTypography>{NEXT_MEETING_LABEL}</CardTitleTypography>
          <CardDateTimeTypography>
            {nextMeeting.date} at {nextMeeting.time}
          </CardDateTimeTypography>
          <JoinButtonWrapper>
            <CustomBtn
              width="auto"
              text={BUTTON_JOIN_MEETING}
              onClick={handleJoinMeeting}
              noIcon
            />
          </JoinButtonWrapper>
        </CardBox>

        <CustomBtn
          width="100%"
          text={BUTTON_VIEW_SCHEDULE}
          onClick={handleViewSchedule}
          noIcon
        />
      </ContentWrapper>
    </RootBox>
  );
};

export default CommunitySupportGroups;
